module.exports = __webpack_public_path__ + "img/fi-rr-package.7d1e012c.svg";